import React, { FunctionComponent } from 'react';

import styled from 'styled-components';

const CircleAnimations: FunctionComponent = () => {
  return (
    <OuterWrapper>
      <CircleAnimation scale={1} />
      <CircleAnimation scale={0.85} />
      <CircleAnimation scale={0.73} />
      <CircleAnimation scale={0.62} />
      <CircleAnimation scale={0.52} />
      <CircleAnimation scale={0.43} />
      <CircleAnimation scale={0.35} />
    </OuterWrapper>
  );
};

const CircleAnimation: FunctionComponent<{ scale: number }> = ({ scale }) => {
  const text = [];
  for (let index = 1; index <= 7; index++) {
    text.push(
      <tspan key={`CLUBFINDER:${index}`}>
        <TSpan light> CLUB</TSpan>
        <TSpan>FINDER </TSpan>
      </tspan>
    );
  }

  return (
    <Wrapper scale={scale}>
      <Svg
        x="0px"
        y="0px"
        width="300px"
        height="300px"
        viewBox="0 0 300 300"
        enable-background="new 0 0 300 300"
      >
        <defs>
          <path
            id="criclePath"
            d=" M 150, 150 m -120, 0 a 120,120 0 0,1 240,0 a 120,120 0 0,1 -240,0 "
          />
        </defs>
        <circle cx="150" cy="150" r="150" fill="none" />
        <g>
          <use href="#criclePath" fill="none" />
          <Text fill="#000">
            <textPath href="#criclePath">{text}</textPath>
          </Text>
        </g>
      </Svg>
    </Wrapper>
  );
};

const Svg = styled.svg`
  position: absolute;
  animation-name: rotate;
  animation-duration: 3s;
  animation-iteration-count: infinite;
  animation-timing-function: cubic-bezier(0.75, 0, 0, 0.75);

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
      filter: blur(0px);
    }
    25% {
      filter: blur(1px);
    }
    50% {
      transform: rotate(45deg);
      filter: blur(0px);
    }
    75% {
      filter: blur(1px);
    }
    100% {
      transform: rotate(0deg);
      filter: blur(0px);
    }
  }
`;

const TSpan = styled.tspan<{ light?: boolean }>`
  font-weight: ${({ light }) => (light ? '300' : '700')};
  letter-spacing: 0.35px;
`;

const Text = styled.text`
  font-family: 'Helvetica Neue', Arial;
  font-size: 16px;
  font-weight: bold;
`;

const Wrapper = styled.div<{ scale: number }>`
  transform: scale(${({ scale }) => scale});
`;
const OuterWrapper = styled.div`
  position: relative;
  width: 300px;
  height: 300px;
  overflow: hidden;

  div:nth-child(1) > svg {
    top: -9px;
    animation-delay: 0.15s;
    z-index: 4;
  }
  div:nth-child(2) > svg {
    top: 17px;
    animation-delay: 0.15s;
    z-index: 4;
  }
  div:nth-child(3) > svg {
    top: 44px;
    animation-delay: 0.45s;
    z-index: 3;
  }
  div:nth-child(4) > svg {
    top: 78px;
    animation-delay: 0.6s;
    z-index: 2;
  }
  div:nth-child(5) > svg {
    top: 121px;
    animation-delay: 0.75s;
    z-index: 1;
  }
  div:nth-child(6) > svg {
    top: 178px;
    animation-delay: 0.9s;
    z-index: 1;
  }
  div:nth-child(7) > svg {
    top: 250px;
    animation-delay: 1.05s;
    z-index: 1;
  }
`;

export default CircleAnimations;
